var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icns8-facebook-f-2","d":"M16.992,8.645H13.645v-1.9c0-.98.08-1.6,1.484-1.6H16.9V2.131A24.744,24.744,0,0,0,14.3,2,4.152,4.152,0,0,0,9.848,6.461V8.645H7v3.8H9.848v8.545h3.8V12.44h2.911Z","transform":"translate(-7 -2)","fill":"#fff"}));
}

Facebook.defaultProps = {"viewBox":"0 0 9.992 18.986"};

module.exports = Facebook;

Facebook.default = Facebook;
